import React, { useEffect, useState } from "react";
import { X, Search } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../lib/i18n";
import api from "../lib/api";

export default function SellModal({ open, onClose, listing, onDone }) {
  const { t } = useI18n();
  const [q, setQ] = useState("");
  const [users, setUsers] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/users").then(r => setUsers(r.data)).catch(() => setUsers([]));
  }, [open]);

  if (!open) return null;

  const filtered = users
    .filter(u => u.id !== listing?.user_id)
    .filter(u => !q || u.name.toLowerCase().includes(q.toLowerCase()) || u.email.toLowerCase().includes(q.toLowerCase()));

  const closeDeal = async (buyerId) => {
    setBusy(true);
    try {
      await api.post("/transactions", { listing_id: listing.id, buyer_id: buyerId });
      toast.success(t("deal_closed"));
      onDone?.();
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("error_generic"));
    } finally { setBusy(false); }
  };

  return (
    <div
      data-testid="sell-modal"
      className="fixed inset-0 bg-black/70 flex items-center justify-center p-4"
      style={{ zIndex: 10001 }}
      onClick={onClose}
    >
      <div className="bg-white rounded-lg max-w-lg w-full p-6 border border-[#E6E2D8]" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div>
            <div className="overline text-[#143122]">{t("mark_as_sold")}</div>
            <h3 className="mt-1 font-serif-display text-2xl text-[#143122]">{t("who_bought")}</h3>
            <div className="text-xs text-[#1A1F1C]/60 mt-1">{listing?.title}</div>
          </div>
          <button data-testid="sell-modal-close" onClick={onClose} className="text-[#1A1F1C]/60 hover:text-[#143122]">
            <X size={20} strokeWidth={1.5} />
          </button>
        </div>

        <div className="mt-5 relative">
          <Search size={14} strokeWidth={1.5} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#1A1F1C]/50" />
          <input
            data-testid="sell-search"
            className="kav-input pl-9"
            placeholder={t("search_buyer")}
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>

        <div className="mt-4 max-h-72 overflow-y-auto border border-[#E6E2D8] rounded-md">
          {filtered.length === 0 ? (
            <div className="p-4 text-sm text-[#1A1F1C]/60">{t("no_users")}</div>
          ) : filtered.map((u) => (
            <button
              key={u.id}
              data-testid={`pick-buyer-${u.id}`}
              disabled={busy}
              onClick={() => closeDeal(u.id)}
              className="w-full text-left px-4 py-3 border-b border-[#E6E2D8] last:border-b-0 hover:bg-[#F4F1E9] transition-colors"
            >
              <div className="font-medium text-[#1A1F1C]">{u.name}</div>
              <div className="text-xs text-[#1A1F1C]/60">{u.email} · {u.role}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
